import { render, staticRenderFns } from "./PN2.vue?vue&type=template&id=28977086&"
import script from "./PN2.vue?vue&type=script&lang=js&"
export * from "./PN2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports